import { render } from "./Step5Summary.vue?vue&type=template&id=53958bd6&scoped=true"
import script from "./Step5Summary.vue?vue&type=script&lang=js"
export * from "./Step5Summary.vue?vue&type=script&lang=js"

import "./Step5Summary.vue?vue&type=style&index=0&id=53958bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53958bd6"]])

export default __exports__